
import React from 'react';
import { useLanguage } from '../App';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { siteConfig } from '../config/site';

const FAQPage: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="bg-primary min-h-screen pt-32 sm:pt-48 pb-24 px-6 overflow-hidden">
      <div className="max-w-3xl mx-auto reveal reveal-up active">
        <div className="text-center mb-16 sm:mb-24">
          <HelpCircle size={48} className="text-accent/30 mx-auto mb-8" />
          <h1 className="text-4xl sm:text-7xl font-serif font-bold uppercase accent-text-gradient tracking-widest mb-6">Frequently Asked Questions</h1>
          <p className="text-white/40 italic font-light text-lg">Everything you need to know about the elite mobile experience.</p>
        </div>
        
        <div className="space-y-6">
          {t.faq.map((item: any, idx: number) => (
            <details key={idx} className="group bg-secondary/30 border border-white/5 open:border-accent/30 transition-all shadow-lg">
              <summary className="flex items-center justify-between p-8 sm:p-10 cursor-pointer list-none">
                <span className="font-bold uppercase text-xs sm:text-sm tracking-[0.2em] text-white/80 group-open:text-accent transition-colors pr-4">{item.q}</span>
                <ChevronDown className="text-accent group-open:rotate-180 transition-transform shrink-0" />
              </summary>
              <div className="px-8 pb-10 sm:px-10 sm:pb-12 text-base sm:text-lg text-white/50 leading-relaxed border-t border-white/5 pt-8 font-light italic">
                {item.a}
              </div>
            </details>
          ))}
          
          <div className="mt-20 p-10 bg-accent/5 border border-accent/10 text-center rounded-sm">
            <h3 className="text-white font-serif font-bold uppercase tracking-widest mb-4">Still have questions?</h3>
            <p className="text-white/50 mb-8 text-sm">Reach out directly to Santi for custom requests or location inquiries.</p>
            <a 
              href={`tel:${siteConfig.phone}`}
              className="inline-block px-12 py-4 bg-accent text-black font-black uppercase tracking-widest text-[10px] hover:bg-white transition-all shadow-xl"
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
